import { render, staticRenderFns } from "./HelpChildList.vue?vue&type=template&id=2cf5018d&scoped=true&"
import script from "./HelpChildList.vue?vue&type=script&lang=js&"
export * from "./HelpChildList.vue?vue&type=script&lang=js&"
import style0 from "./HelpChildList.vue?vue&type=style&index=0&id=2cf5018d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5018d",
  null
  
)

export default component.exports